import { CalendarDays, CalendarRange, Settings2, ShieldCheck, TrendingUp } from 'lucide-react';
import type { ModuleNav } from '@/components/layout/module-nav';

/**
 * Gastronomy's navigation.
 *
 * Settings are open to everyone who sees gastronomy and read-only without
 * `canEditGastronomySettings`. The collector's token is its data source's, on
 * Administracja → Źródła danych.
 */
export const GASTRONOMY_NAV: ModuleNav = {
  left: [
    [
      { to: '/gastronomy', labelKey: 'gastronomy.nav.today', icon: CalendarDays },
      { to: '/gastronomy/results', labelKey: 'gastronomy.nav.results', icon: TrendingUp },
      { to: '/gastronomy/forward', labelKey: 'gastronomy.nav.forward', icon: CalendarRange },
      { to: '/gastronomy/controls', labelKey: 'gastronomy.nav.controls', icon: ShieldCheck },
    ],
  ],
  right: [
    { to: '/gastronomy/settings', labelKey: 'gastronomy.nav.settings', icon: Settings2 },
  ],
};
